// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2f81b6f","455":"de60688b"}[chunkId] + ".chunk.js";
};